class CartNotificationToast extends HTMLElement {
  connectedCallback() {
    this.#interceptCartAdd();
  }

  #interceptCartAdd() {
    // Intercept fetch calls to /cart/add
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      
      // Check if this is a cart add request
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (url && url.includes('/cart/add')) {
        console.log('Cart add detected!');
        
        // Clone response so we don't consume it
        const clonedResponse = response.clone();
        
        if (clonedResponse.ok) {
          try {
            const addedData = await clonedResponse.json();
            console.log('Added item data:', addedData);
            
            // Fetch full cart to get complete item details
            const cartResponse = await originalFetch('/cart.js');
            const cart = await cartResponse.json();
            
            if (cart.items && cart.items.length > 0) {
              const lastItem = cart.items[cart.items.length - 1];
              console.log('Showing toast for:', lastItem);
              this.#showToast(lastItem);
            }
          } catch (e) {
            console.error('Error handling cart add:', e);
          }
        }
      }
      
      return response;
    };
  }

  #showToast(item) {
    const toast = document.createElement('div');
    toast.className = 'cart-notification-toast';
    toast.innerHTML = `
      <div class="cart-notification-toast__content">
        <div class="cart-notification-toast__header">Item Added to Cart</div>
        <div class="cart-notification-toast__item">
          <img src="${item.featured_image?.url || item.image}" alt="${item.product_title}" class="cart-notification-toast__image">
          <div class="cart-notification-toast__details">
            <div class="cart-notification-toast__title">${item.product_title}</div>
            <div class="cart-notification-toast__variant">${item.variant_title || ''}</div>
            <div class="cart-notification-toast__price">${this.#formatMoney(item.final_price)}</div>
          </div>
        </div>
        <div class="cart-notification-toast__buttons">
          <a href="/checkout" class="cart-notification-toast__button cart-notification-toast__button--checkout">Checkout</a>
          <a href="/cart" class="cart-notification-toast__button cart-notification-toast__button--view">View Cart</a>
        </div>
      </div>
    `;

    document.body.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(() => {
      toast.classList.add('cart-notification-toast--visible');
    });

    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      toast.classList.remove('cart-notification-toast--visible');
      setTimeout(() => {
        toast.remove();
      }, 300); // Wait for fade out animation
    }, 3000);
  }

  #formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }
}

if (!customElements.get('cart-notification-toast')) {
  customElements.define('cart-notification-toast', CartNotificationToast);
}
